import { heatClass } from "./flashTheme";

export const FlashHeatmap = ({ data }) => (
  <section className="flash-rise bg-white p-6 rounded-xl shadow-sm border border-slate-200 space-y-4" style={{ animationDelay: "500ms" }}>
    <div className="flex flex-wrap items-end justify-between gap-3">
      <div>
        <h2 className="font-heading font-semibold text-lg text-slate-900">Month-by-month goal-metric trend</h2>
        <p className="text-sm text-slate-500">Last 6 months · each month shows its latest entry · current month is month-to-date</p>
      </div>
      <div className="flex items-center gap-3 text-[11px] text-slate-500">
        <span className="flex items-center gap-1"><i className="w-3 h-3 rounded bg-emerald-500" />At goal</span>
        <span className="flex items-center gap-1"><i className="w-3 h-3 rounded bg-amber-300" />Within 5</span>
        <span className="flex items-center gap-1"><i className="w-3 h-3 rounded bg-rose-300" />5–15 under</span>
        <span className="flex items-center gap-1"><i className="w-3 h-3 rounded bg-rose-500" />15+ under</span>
      </div>
    </div>
    <div className="overflow-x-auto">
      <table className="w-full border-separate border-spacing-1.5 text-sm" data-testid="heatmap-trend-table">
        <thead>
          <tr>
            <th className="text-left text-[11px] uppercase tracking-wider text-slate-500 font-heading font-semibold pr-4">Form</th>
            <th className="text-[11px] uppercase tracking-wider text-slate-500 font-heading font-semibold">Goal</th>
            {data.trend_months.map((m, i) => (
              <th
                key={m.month}
                className={`text-[11px] uppercase tracking-wider font-heading font-semibold ${i === data.trend_months.length - 1 ? "text-sky-700" : "text-slate-500"}`}
              >
                {m.label}
                {i === data.trend_months.length - 1 && <span className="block text-[9px] normal-case tracking-normal">MTD</span>}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.forms.map((f) => (
            <tr key={f.id} data-testid={`heatmap-row-${f.id}`}>
              <td className="pr-4 font-medium text-slate-800 whitespace-nowrap">{f.name}</td>
              <td className="text-center font-mono text-xs text-slate-500">{f.goal_pct}%</td>
              {f.trend.map((t, i) => (
                <td
                  key={t.month}
                  className={`text-center font-mono text-xs font-semibold rounded-md py-2.5 min-w-[72px] ${heatClass(t.on_time_pct, f.goal_pct)} ${i === f.trend.length - 1 ? "ring-2 ring-sky-600 ring-offset-1" : ""}`}
                >
                  {t.on_time_pct === null ? "—" : `${t.on_time_pct.toFixed(1)}%`}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </section>
);
